var MantleAnimation = (function(MantleAnimation, $) {

  return MantleAnimation;
})(MantleAnimation || {}, jQuery);
